(function () {
  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function applyImage(img, src, alt) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
    img.src = src;
    if (alt) {
      img.setAttribute('alt', alt);
      img.alt = alt;
    }
  }

  function getMedia(card) {
    return card.querySelector('.card__media .media');
  }

  function ensureSecondary(media, primary) {
    var images = media.querySelectorAll('img');
    if (images.length >= 2) return images[1];
    if (!primary) return null;
    var clone = primary.cloneNode(true);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.setAttribute('data-saltless-secondary', 'true');
    media.appendChild(clone);
    return clone;
  }

  function showPrimary(card) {
    var media = getMedia(card);
    if (!media) return;
    media.classList.remove('is-showing-secondary');
    card.dataset.saltlessShowing = 'primary';
  }

  function showSecondary(card) {
    if (card.dataset.saltlessHasFlip !== 'true') {
      showPrimary(card);
      return;
    }
    if (card.classList.contains('saltless-swatch-previewing')) {
      showPrimary(card);
      return;
    }
    var media = getMedia(card);
    if (!media) return;
    var images = media.querySelectorAll('img');
    if (images.length < 2 || !images[1].getAttribute('src')) {
      showPrimary(card);
      return;
    }
    media.classList.add('is-showing-secondary');
    card.dataset.saltlessShowing = 'hover';
  }

  function applyColorPair(card, button) {
    var src = button.getAttribute('data-image-src');
    var hoverSrc = button.getAttribute('data-image-hover-src');
    var alt = button.getAttribute('data-image-alt') || '';
    if (!src || !card) return false;

    var media = getMedia(card);
    if (!media) return false;

    media.classList.remove('media--hover-effect');
    media.classList.add('saltless-media-pair');
    media.classList.remove('is-showing-secondary');

    var images = media.querySelectorAll('img');
    if (!images.length) return false;

    applyImage(images[0], src, alt);

    if (hoverSrc) {
      card.dataset.saltlessHasFlip = 'true';
      var secondary = ensureSecondary(media, images[0]);
      applyImage(secondary, hoverSrc, alt);
      secondary.style.removeProperty('display');
    } else {
      card.dataset.saltlessHasFlip = 'false';
      images = media.querySelectorAll('img');
      for (var i = 1; i < images.length; i++) {
        images[i].style.setProperty('display', 'none', 'important');
      }
    }

    card.dataset.saltlessShowing = 'primary';
    return true;
  }

  function setActive(group, button) {
    group.querySelectorAll('.saltless-card-swatch').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');
  }

  function onActivate(button) {
    var group = button.closest('[data-saltless-swatches]');
    var card = button.closest('.product-card-wrapper');
    if (!group || !card) return;
    if (!button.getAttribute('data-image-src')) return;
    setActive(group, button);
    applyColorPair(card, button);
    showPrimary(card);
  }

  function toggleFlip(card) {
    if (card.dataset.saltlessHasFlip !== 'true') return;
    if (card.dataset.saltlessShowing === 'hover') showPrimary(card);
    else showSecondary(card);
  }

  function prepareCards() {
    document.querySelectorAll('[data-saltless-swatches]').forEach(function (group) {
      var card = group.closest('.product-card-wrapper');
      if (!card) return;
      var active =
        group.querySelector('.saltless-card-swatch.is-active') ||
        group.querySelector('.saltless-card-swatch');
      if (active && active.getAttribute('data-image-src')) {
        onActivate(active);
      } else {
        // Keep server-rendered primary visible; kill Dawn hover only
        var media = getMedia(card);
        if (media) {
          media.classList.remove('media--hover-effect');
          media.classList.add('saltless-media-pair');
          media.classList.remove('is-showing-secondary');
          card.dataset.saltlessHasFlip = 'false';
          var images = media.querySelectorAll('img');
          for (var i = 1; i < images.length; i++) {
            images[i].style.setProperty('display', 'none', 'important');
          }
        }
      }

      var mediaWrap = card.querySelector('.card__media');
      if (!mediaWrap || mediaWrap.dataset.saltlessHoverBound) return;
      mediaWrap.dataset.saltlessHoverBound = '1';

      if (fineHover) {
        mediaWrap.addEventListener('pointerenter', function () {
          if (card.classList.contains('saltless-swatch-previewing')) return;
          showSecondary(card);
        });
        mediaWrap.addEventListener('pointerleave', function () {
          showPrimary(card);
        });
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button.saltless-card-swatch');
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        onActivate(button);
        return;
      }

      if (fineHover) return;
      var mediaHit = event.target.closest('.product-card-wrapper .card__media');
      if (!mediaHit) return;
      var card = mediaHit.closest('.product-card-wrapper');
      if (!card || !card.querySelector('[data-saltless-swatches]')) return;
      if (card.dataset.saltlessHasFlip !== 'true') return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      toggleFlip(card);
    },
    true
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      var button = event.target.closest('button.saltless-card-swatch');
      if (!button) return;
      var card = button.closest('.product-card-wrapper');
      if (!card) return;
      if (!button.getAttribute('data-image-src')) return;
      applyColorPair(card, button);
      showPrimary(card);
      card.classList.add('saltless-swatch-previewing');
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var group = event.target.closest('[data-saltless-swatches]');
      if (!group) return;
      var related = event.relatedTarget;
      if (related && group.contains(related)) return;
      var card = group.closest('.product-card-wrapper');
      if (!card) return;
      card.classList.remove('saltless-swatch-previewing');
      var active =
        group.querySelector('.saltless-card-swatch.is-active') ||
        group.querySelector('.saltless-card-swatch');
      if (active && active.getAttribute('data-image-src')) applyColorPair(card, active);
      showPrimary(card);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var button = event.target.closest('button.saltless-card-swatch');
    if (!button) return;
    event.preventDefault();
    onActivate(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareCards);
  } else {
    prepareCards();
  }
})();
